/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Модель создания или обновления авторов.
 */
export const createOrUpdateAuthorModelSchema = z.object({
    "nickname": z.string().max(150).describe("Псевдоним"),
"contactInfo": z.string().max(1500).describe("Контактная информация").nullable().nullish(),
"description": z.string().max(2000).describe("Описание").nullable().nullish(),
"pictureFileId": z.string().uuid().describe("Идентификатор аватара автора.").nullable().nullish(),
"church": z.string().max(200).describe("Церковь").nullable().nullish()
    }).describe("Модель создания или обновления авторов.")